import React from 'react';
import Link from '../../Buttons/Link/Link';
import '../ErrorPage.scss';
import logoDark from '../../../images/logo_dark.svg';
import dog from '../../../images/inactive-account.jpg';

const InactiveAccount = ({ goBack, hideBackButton }) => {
  return (
    <section className="error-page">
      <img src={logoDark} className="error-logo" alt="concept3d dark logo" />
      <h1>Tour Builder</h1>
      <h3>This tour is inactive</h3>
      <p>
        The requested tour or account is no longer available, please select
        another tour to view
      </p>
      <img
        src={dog}
        className="tour-not-found-image"
        alt="This tour is inactive"
      />
      {!hideBackButton && (
        <Link handleClick={goBack}>
          <button className="go-back-btn">Tour Builder Home</button>
        </Link>
      )}
    </section>
  );
};

export default InactiveAccount;
